import { useEffect } from 'react';

const SEO = ({ noindex = false, nofollow = false }) => {
  useEffect(() => {
    if (noindex || nofollow) {
      const metaRobots = document.createElement('meta');
      metaRobots.name = 'robots';
      metaRobots.content = `${noindex ? 'noindex' : 'index'}, ${nofollow ? 'nofollow' : 'follow'}`;
      document.head.appendChild(metaRobots);
      
      return () => {
        const existingMeta = document.querySelector('meta[name="robots"]');
        if (existingMeta) {
          document.head.removeChild(existingMeta);
        }
      };
    }
  }, [noindex, nofollow]);

  return null;
};

export default SEO;
